// Welcome — animated TMC logo + command guide. Drop into
// ClientApp/src/components/Welcome.jsx.
//
// Shown in the empty conversation pane (hint=true → includes the "pick a
// channel" line) and inside a channel that has no messages yet (hint=false).
// Pure presentational, no props beyond `hint`. The .welcome* CSS lives in
// styles.css (see styles.additions.css). The logo references /tmc-logo.png,
// which already ships in ClientApp/public/.

import { TRIGGER_GUIDE } from "../commands.js";

export default function Welcome({ hint = true }) {
  return (
    <div className="welcome">
      <div className="welcome__logo">
        <span className="welcome__ring welcome__ring--1" />
        <span className="welcome__ring welcome__ring--2" />
        <span className="welcome__mark" />
      </div>
      <h2 className="welcome__title">Welcome to <b>TMC<span>Chat</span></b></h2>
      <p className="welcome__sub">
        {hint
          ? "Pick a channel on the left to start chatting — here's what you can type in any conversation:"
          : "Here's what you can type in any conversation:"}
      </p>
      <ul className="welcome__cmds">
        {TRIGGER_GUIDE.map(([c, d]) => (<li key={c}><code>{c}</code><span>{d}</span></li>))}
      </ul>
    </div>
  );
}
